<template>
  <div class="order_detail">
    <div class="order_detail_nav">
      <navbar
        title="订单详情"
        :lefticon="lefticon"
        :lefticonheight="1.8"
        :lefticonwidth="1.8"
        :fontweight="700"
        :fontsize="'1.8rem'"
        @goback="goBack(false)"
      />
    </div>
    <div class="box">
      <van-row>
        <van-col span="24" class="status"> {{ statusTit }}</van-col>
        <van-col span="24" class="tip"> {{ statusTip }}</van-col>
      </van-row>
      <van-row
        class="refund_money"
        v-if="detailInfo.status == 70 || detailInfo.status == 80"
      >
        <van-col span="24"
          >退还金额：<span>￥{{ detailInfo.actual_refund }}</span></van-col
        >
      </van-row>
      <van-row class="phone_info">
        <van-col span="24" class="num">
          退还手机数量<span>共1台</span>
        </van-col>
        <van-col span="24" class="price">
          实付金额<span>2000.00</span>
        </van-col>
        <van-col span="24" class="pay">
          申退金额：
          <span class="money">
            ￥<span class="num">2000<span>.00</span></span>
          </span>
        </van-col>
      </van-row>
      <van-row class="show_address_refund">
        <van-col span="24" class="title">退还地址信息</van-col>
        <van-col span="24" class="show_address">
          <span class="address">
            <img src="../../../assets/accountAgent/common/address.png" alt="" />
          </span>
          <p class="name">
            {{ detailInfo.return_realname }}
            <span>{{ detailInfo.return_mobile }}</span>
          </p>
          <p class="site">
            {{ detailInfo.return_address }}
          </p>
        </van-col>
      </van-row>

      <van-row class="order_info">
        <van-col span="24" class="title">订单信息</van-col>
        <van-col span="24" class="item">
          <span class="label">退还订单编号：</span>
          <span class="_copy" ref="copytxt1">{{ detailInfo.sale_sn }}</span>
          <span class="copy" @click="copyCode(1)">复制</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.return_post_name">
          <span class="label">物流公司：</span>
          <span>{{ detailInfo.return_post_name }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.return_post_no">
          <span class="label">物流编号：</span>
          <span class="_copy" ref="copytxt2">{{
            detailInfo.return_post_no
          }}</span>
          <span class="copy" @click="copyCode(2)">复制</span>
        </van-col>
        <van-col span="24" class="item">
          <span class="label">申请退还时间：</span>
          <span>{{ detailInfo.created_at }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.status == -20">
          <span class="label">申请撤销时间：</span>
          <span>{{ detailInfo.reject_time }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.status == -10">
          <span class="label">申请驳回时间：</span>
          <span>{{ detailInfo.reject_time }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.status >= 60">
          <span class="label">申请通过时间：</span>
          <span>{{ detailInfo.agree_time }}</span>
        </van-col>
        <van-col span="24" class="item" v-if="detailInfo.status == 80">
          <span class="label">退还成功时间：</span>
          <span>{{ detailInfo.updated_at }}</span>
        </van-col>
        <!-- <van-col span="24" class="item">
          <span class="label">下单时间：</span>
          <span>2020-09-10 12：09：08</span>
        </van-col> -->
        <!-- <van-col span="24" class="item">
          <span class="label">支付时间：</span>
          <span>2020-09-10 12：09：10</span>
        </van-col> -->
        <van-col span="24" class="item">
          <span class="label">购买会员：</span>
          <span> {{ detailInfo.user_name }} </span>
        </van-col>
        <van-col span="24" class="item">
          <span class="label">会员手机号：</span>
          <span>{{ detailInfo.user_mobile }}</span>
        </van-col>
        <van-col span="24" class="item">
          <span class="label">退还原因：</span>
          <span> {{ detailInfo.reason }} </span>
        </van-col>
      </van-row>
    </div>
    <van-row class="order_detail_footer">
      <van-col span="24">
        <btn
          :btntext="'查看协议'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status > 20"
          @btnClick="seeSinature(detailInfo)"
        />
        <btn
          :btntext="'申请退还'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == -10"
          @btnClick="refundPhone(detailInfo)"
        />
        <btn
          :btntext="'联系客服'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          @btnClick="contract"
        />
        <!-- <btn
          :btntext="'删除订单'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#666'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #eee'"
          :btnmargin="'0 0 0 1.2rem'"
          @btnClick="delect(item)"
        /> -->
        <btn
          :btntext="'撤销申请'"
          :btnwidth="'8.4rem'"
          :height="'3.2rem'"
          :bgcolor="'#fff'"
          :borderradius="'1.6rem'"
          :btncolor="'#F9591B'"
          :fontsize="'1.5rem'"
          :btnborder="'solid 0.1rem #F9591B'"
          :btnmargin="'0 0 0 1.2rem'"
          v-if="detailInfo.status == 10"
          @btnClick="revoke(itedetailInfom)"
        />
      </van-col>
    </van-row>
    <a ref="phone" href="tel:4000571671"></a>
  </div>
</template>
<script>
import navbar from "../components/nav-bar.vue";
import btn from "../components/button.vue";
export default {
  components: {
    navbar,
    btn,
  },
  data() {
    return {
      lefticon: require("@/assets/accountAgent/common/back.png"),
      detailShow: false,
      statusTit: "",
      statusTip: "",
      detailInfo: {},
    };
  },
  created() {
    //orderId 售后订单
    this.getInfo();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    getInfo() {
      this.$api
        .post("/investment/member/agent/order/after/detail", {
          id: this.$route.query.orderId,
        })
        .then((res) => {
          this.detailInfo = res;
          if (res.status == 10) {
            this.statusTit = "退还申请中";
            this.statusTip = "已提交申请，请耐心等待！";
          } else if (res.status == -10) {
            this.statusTit = "退还申请被驳回";
            this.statusTip = res.reject_reason;
          } else if (res.status == 60) {
            this.statusTit = "退还申请通过";
            this.statusTip = "您的退还申请已通过，请耐心等待！";
          } else if (res.status == 70) {
            this.statusTit = "退款中";
            this.statusTip = "您的订单正在退款中，请耐心等待！";
          } else if (res.status == 80) {
            this.statusTit = "退还成功";
            this.statusTip = "您的订单退还成功，感谢您对销巴的支持！";
          } else if (res.status == -20) {
            this.statusTit = "申请已撤销";
            this.statusTip = "您的退还申请已撤销！";
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    changeDetailShow() {
      this.detailShow = !this.detailShow;
    },
    copyCode(index) {
      const rechage_range = document.createRange();
      if (index == 1) {
        rechage_range.selectNode(this.$refs.copytxt1);
      } else {
        rechage_range.selectNode(this.$refs.copytxt2);
      }
      const rechage_selection = window.getSelection();
      if (rechage_selection.rangeCount > 0) rechage_selection.removeAllRanges();
      rechage_selection.addRange(rechage_range);
      document.execCommand("Copy");
      this.$toast("复制成功");
      rechage_selection.removeAllRanges();
    },
    seeSinature(item) {
      this.$router.push({
        path: "/accountAgent/electroniContract",
        query: {
          ordersn: item.ordersn,
        },
      });
    },
    refundPhone(item) {
      this.$router.push({
        path: "/accountAgent/refund",
        query: {
          ordersn: item.ordersn,
        },
      });
    },
    contract() {
      this.$dialog
        .confirm({
          message: "4000571671",
          confirmButtonText: "立即呼叫",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          // this.$refs.phone.click();
          // this.params("4000571671", "4000571671", "contract");
          let ua = navigator.userAgent.toLowerCase();
          if (
            /iphone|ipad|ipod|macintosh/i.test(ua) &&
            !this.$route.query.from
          ) {
            this.params("4000571671", "4000571671", "contract");
          } else {
            this.$refs.phone.click();
          }
        });
    },
    revoke(item) {
      this.$dialog
        .confirm({
          message: "您确定要撤销申请",
          confirmButtonText: "确定",
          confirmButtonColor: "#f9591b",
          cancelButtonText: "取消",
          cancelButtonColor: "#999",
        })
        .then(() => {
          // on confirm
          this.$api
            .post("investment/member/agent/order/after/cancel", {
              id: item.order_id,
            })
            .then((res) => {
              this.$toast("申请已提交成功");
              var length = this.page;
              this.list = [];
              this.page = 0;
              for (var j = 0; j < length; j++) {
                this.page = j + 1;
                this.getInfo();
              }
            })
            .catch((err) => {
              this.hasList = false;
              let keys = Object.keys(err);
              let key = keys[0];
              let message = err.message || err[key][0];
              if (message.slice(0, 10) == "timeout of") {
                this.$toast("网络不给力，请稍候重试");
                this.timeout = true;
              } else {
                this.$toast(message);
              }
            });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.order_detail {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .order_detail_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #f5f6f7;
    z-index: 3;
  }

  .box {
    padding: 10rem 1.2rem 6.5rem;
    box-sizing: border-box;
    height: 100%;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .status {
      color: #333;
      font-size: 1.8rem;
      padding-left: 1.2rem;
      height: 2.9rem;
      line-height: 2.9rem;
    }

    .tip {
      color: #666;
      font-size: 1.4rem;
      padding: 0 1.2rem;
      margin: 0.2rem 0 1.2rem;
      line-height: 2.3rem;
    }

    .show_address {
      min-height: 8.5rem;
      padding: 1.5rem 1rem 1.5rem 5.1rem;
      background: #fff;
      border-radius: 0.6rem;
      margin-bottom: 1rem;
      text-align: left;
      position: relative;
      box-sizing: border-box;

      .address {
        width: 5.1rem;
        padding-left: 1rem;
        min-height: 8.5rem;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        display: flex;
        align-items: center;
        box-sizing: border-box;

        img {
          width: 2.6rem;
        }
      }

      .name {
        color: #333;
        font-size: 1.6rem;
        font-weight: 700;
        height: 2.6rem;
        line-height: 2.6rem;
        margin-bottom: 0.6rem;

        span {
          margin-left: 3rem;
        }
      }

      .site {
        color: #999;
        font-size: 1.4rem;
        line-height: 2.3rem;
      }
    }

    .show_address_refund {
      min-height: 11.5rem;
      background: #fff;
      border-radius: 0.6rem;
      margin-bottom: 1rem;
      padding-top: 1.2rem;
      box-sizing: border-box;

      .title {
        color: #333;
        font-size: 1.4rem;
        height: 2.4rem;
        line-height: 2.4rem;
        padding: 0 1.2rem;
      }

      .show_address {
        min-height: 7.9rem;
        margin-bottom: 0;
        padding: 1.2rem 1rem 1.2rem 5.1rem;
      }
    }

    .refund_money {
      color: #333;
      font-size: 1.4rem;
      height: 5.4rem;
      line-height: 5.4rem;
      padding: 0 1.2rem;
      background: #fff;
      border-radius: 0.5rem;
      box-sizing: border-box;
      margin-bottom: 1rem;

      span {
        color: #f9591b;
      }
    }

    .phone_info {
      height: 12.5rem;
      border-radius: 0.6rem;
      background: #fff;
      padding: 1.2rem;
      color: #333;
      font-size: 1.4rem;
      box-sizing: border-box;
      margin-bottom: 1rem;

      .num {
        color: #333;
        height: 2.4rem;
        line-height: 2.4rem;

        span {
          float: right;
        }
      }

      .price {
        color: #999;
        height: 2.3rem;
        line-height: 2.3rem;
        margin-top: 1.2rem;

        span {
          color: #333;
          float: right;
        }
      }

      .pay {
        color: #333;
        text-align: right;
        margin-top: 1.2rem;

        .money {
          font-size: 1.3rem;
          font-weight: 700;
          margin-left: 0.2rem;

          .num {
            font-size: 2.2rem;

            span {
              font-size: 1.6rem;
            }
          }
        }
      }
    }

    .order_info {
      height: auto;
      border-radius: 0.6rem;
      background: #fff;
      padding: 1.2rem 1.2rem 1.5rem;
      color: #333;
      font-size: 1.3rem;
      box-sizing: border-box;

      .title {
        font-size: 1.4rem;
        font-weight: 700;
        height: 2.4rem;
        line-height: 2.4rem;
      }

      .item {
        line-height: 1.4rem;
        margin-top: 1.6rem;

        span {
          float: left;
          width: calc(100% - 9.3rem);
        }

        ._copy {
          width: calc(100% - 16.7rem);
        }

        .label {
          color: #999;
          width: 9.3rem;
        }

        .copy {
          float: right;
          color: #f9591b;
          width: 5rem;
          height: 2.3rem;
          line-height: 2.3rem;
          text-align: center;
          border-radius: 0.2rem;
          border: solid 0.1rem #f9591b;
          margin-top: -0.5rem;
        }
      }
    }
  }

  .order_detail_footer {
    height: 5rem;
    padding: 0.7rem 1.2rem 0;
    background: #fff;
    text-align: right;
    box-sizing: border-box;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}
</style>
<style lang="less">
.van-dialog {
  border-radius: 0;

  .van-dialog__confirm,
  .van-dialog__cancel {
    height: 5.2rem;
    font-size: 1.6rem;
  }

  .van-dialog__content--isolated {
    min-height: 6.2rem;

    .van-dialog__message {
      padding: 2.1rem 1rem;
      color: #333;
      font-weight: 700;
      font-size: 1.6rem;
    }
  }
}
</style>